import { Dialog, IconButton, Alert } from '@mui/material';
import { MovementReconciliationActions } from '../../bancos/MovementReconciliationActions';
import CloseIcon from '@mui/icons-material/Close';

import { CobrosForm } from './CobrosForm';

export const CobrosDialogForm = ({ initialData, title, openModal, setModal, dataFactura, checkInitialData }) => {
    
    return (
        <Dialog
            className='dialogoCrearPagos'
            open={openModal}
            onClose={() => setModal(false)}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    {title}
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={() => setModal(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>

                {initialData.reconciled ? <>
                    <Alert severity="info">Este cobro está conciliado. Deshaz primero su conciliación para editarlo o eliminarlo.</Alert>
                    <MovementReconciliationActions movement={initialData} type="ingreso" onChanged={async()=>{if(typeof checkInitialData==='function')await checkInitialData(initialData.id_factura);setModal(false);}}/>
                </> : <CobrosForm
                    setModal={setModal}
                    initialData={initialData}
                    checkInitialData={checkInitialData}
                />}

            </div>
        </Dialog>
    )
}
